import { Button, PhoneInput } from "ui2";

import { SubScreenHeader } from "safety/components/attendance/SubScreenHeader";

type ForgotPinScreenProps = {
  meetingName: string;
  phone: string;
  sent: boolean;
  submitting: boolean;
  onPhoneChange: (value: string) => void;
  onSubmit: () => void;
  onBack: () => void;
};

export const ForgotPinScreen = ({
  meetingName,
  phone,
  sent,
  submitting,
  onPhoneChange,
  onSubmit,
  onBack,
}: ForgotPinScreenProps): React.JSX.Element => (
  <>
    <SubScreenHeader meetingName={meetingName} onBack={onBack} />
    <div className="tw:flex tw:w-full tw:flex-1 tw:flex-col tw:gap-4 tw:p-5">
      {sent ? (
        <div className="tw:flex tw:flex-1 tw:flex-col tw:items-center tw:justify-center tw:gap-4 tw:text-center">
          <h1 className="tw:m-0 tw:text-2xl tw:font-denim tw:text-midnight">Check your texts</h1>
          <div className="tw:max-w-90 tw:text-sm tw:text-midnight/60">
            We’ve texted your PIN to the number on file.
          </div>
          <Button variant="outline" onClick={onBack}>
            Back to PIN
          </Button>
        </div>
      ) : (
        <>
          <h1 className="tw:m-0 tw:text-2xl tw:font-denim tw:text-midnight">Forgot your PIN?</h1>
          <PhoneInput label="Phone number" value={phone} autoFocus onChange={onPhoneChange} />
          <div className="tw:mt-auto tw:pt-2">
            <Button
              size="lg"
              className="tw:w-full tw:sm:w-auto"
              disabled={!phone.trim() || submitting}
              onClick={onSubmit}
            >
              Send PIN
            </Button>
          </div>
        </>
      )}
    </div>
  </>
);
